export const environment = {
  production: false,
    firebaseConfig: {
      apiKey: "AIzaSyCTyIAR4_HZPMHLKXWoC_cK9xUvcPii-w0",
      authDomain: "helageek-dev.firebaseapp.com",
      projectId: "helageek-dev",
      storageBucket: "helageek-dev.firebasestorage.app",
      messagingSenderId: "167931748880",
      appId: "1:167931748880:web:efa60c00a08730a2f06095",
      measurementId: "G-24H4ZC6DMT"
    }
    // firebaseConfig: {
    //     apiKey: "AIzaSyDKMXfgMRUpIlHAba3bxgHmByTNI_qTmn8",
    //     authDomain: "helageek-b132a.firebaseapp.com",
    //     projectId: "helageek-b132a",
    //     storageBucket: "helageek-b132a.firebasestorage.app",
    //     messagingSenderId: "967416320900",
    //     appId: "1:967416320900:web:64c62e84feb4bf2c7903d1",
    //     measurementId: "G-860049Q2JL"
    // }
};
